import { makeStyles } from '@material-ui/core';
import ScrollContainer from 'react-indiana-drag-scroll';
import themes from 'styles/themes';
import { Waypoint } from 'react-waypoint';
import { useCallback } from 'react';
import { checkIsPersonalizedStyle, getProductTrackingData } from 'utils/trackUtils';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { TRACK_EVENT, trackEvent } from 'utils/analytics';

export default function CardSlider(props) {
    const { list, onItemClick, styleType } = props;
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const useStyles = makeStyles((theme) => ({
        cardImageContainer: {
            width: `180px`,
            height: `239px`,
            background: '#ffffff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '0.4rem',
            cursor: 'pointer',
        },
        cardImage: {
            width: 'auto',
            height: '100%',
            objectFit: 'scale-down',
            margin: 'auto',
            maxWidth: '100%',
            borderRadius: '0.4rem',
        },
        categoryName: {
            fontFamily: 'PoppinsRegular',
            fontSize: `14px`,
            fontWeight: 700,
            color: themes.palette.primary.main,
        },
        stylistName: {
            fontFamily: 'Montserrat',
            fontSize: `12px`,
            fontWeight: 400,
            color: themes.palette.primary.main,
        },
    }));
    const classes = useStyles();

    const trackProductView = useCallback(
        (styleData) => {
            const productViewTrackingData = {
                ...getProductTrackingData(userDetail, styleData, styleData),
                personalized: checkIsPersonalizedStyle(styleData, userDetail),
            };
            trackEvent(TRACK_EVENT.PRODUCT_VIEW, productViewTrackingData);
        },
        [userDetail],
    );

    const _handleWaypointEnter = (item) => {
        trackProductView(item);
    };

    return (
        <div>
            <ScrollContainer className="ps-2 pe-3 d-flex w-100 overflow-scroll">
                {list.map((item, index) => {
                    return (
                        <Waypoint onEnter={() => _handleWaypointEnter(item)} horizontal key={index}>
                            <div className="ms-2" onClick={() => onItemClick(item, styleType)}>
                                <div className={`${classes.cardImageContainer}`}>
                                    <img src={item.images[0]} alt="" className={`${classes.cardImage}`} />
                                </div>
                                <div className="mt-2">
                                    <div className={classes.categoryName}>{item?.title || ''}</div>
                                    <div className={classes.stylistName}>{item?.user?.firstName || ''}</div>
                                </div>
                            </div>
                        </Waypoint>
                    );
                })}
            </ScrollContainer>
        </div>
    );
}
